<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="full-height border-box flex-column">
    <div class="w-full drag-bar" cdkDragHandle>
        <fa-icon icon="arrows-alt"></fa-icon>
        <h1 matDialogTitle class="m-0"><fa-icon icon="calculator"></fa-icon> Rechner <app-hint-icon [hint]="hint" [multiline]="true"></app-hint-icon></h1>
        <fa-icon class="close-button" icon="times" size="2x" [mat-dialog-close]=""></fa-icon>
    </div>
    <div matDialogContent class="flex flex-col">
        <div class="flex flex-col grow">
            <mat-form-field>
                <textarea #formulaInput matInput [formControl]="formulaForm" ></textarea>
            </mat-form-field>
            <app-calculation-input-result [formula]="formulaForm.value" [maxDecimalPlaces]="Data.maxDecimalPlaces" [mathScope]="calculationScopeService ? (calculationScopeService.scope$ | async) : undefined"></app-calculation-input-result>
            <mat-error *ngIf="initialResultDosentMatch"><fa-icon icon="exclamation-triangle"></fa-icon> Der Wert wurde manuell geändert</mat-error>
        </div>
        <div class="grow" *ngIf="calculationScopeService">
            <ng-container
                [ngTemplateOutlet]="groupTemplate"
                [ngTemplateOutletContext]="{
                    description: contextVariables.description,
                    variables$: contextVariables.variables$,
                    children: contextVariables.children,
                    groupId: contextVariables.id,
                }"
            ></ng-container>
            <ng-template #groupTemplate let-description="description" let-variables$="variables$" let-children="children" let-groupId="groupId">
                <h3 class="mb-0">{{ description }}</h3>
                <div class="mx-2">
                    <div class="flex items-center" *ngFor="let v of variables$ | async">
                        <div class="flex-item-key">
                            <b>{{ v.key }}</b>
                        </div>
                        <button class="" mat-icon-button (click)="onSelectVariable(v)" matTooltip="Variable einfügen"  (mousedown)="$event.preventDefault()"><fa-icon icon="share"></fa-icon></button>
                        <span class="mx-4">{{ v.value }} <span *ngIf="v.meta.formula && v.meta.formula !== v.value+''" class="font-light">({{v.meta.formula}})</span></span>

                        <div class="flex-item-description grow">
                            <span>{{ v.meta.description }}</span>
                        </div>
                        <button class="" mat-icon-button (click)="onEditClick(v)" matTooltip="Variable bearbeiten"><fa-icon icon="pencil-alt"></fa-icon></button>
                    </div>

                    <button style="float: right" mat-icon-button (click)="onAddClick(groupId)" [disabled]="disabled" matTooltip="Variable hinzufügen"><fa-icon icon="plus"></fa-icon></button>
                    <ng-container
                        [ngTemplateOutlet]="groupTemplate"
                        *ngFor="let c of children"
                        [ngTemplateOutletContext]="{
                            description: c.description,
                            variables$: c.variables$,
                            children: c.children,
                            groupId: c.id,
                        }"
                    ></ng-container>
                </div>
            </ng-template>
        </div>
    </div>
    <mat-dialog-actions class="flex gap-4 justify-between">
        <button app-button Color="cancel" Inverted [mat-dialog-close]="">abbrechen</button>
        <button app-button Color="green" [Disabled]="disabled" (click)="close()">übernehmen</button>
    </mat-dialog-actions>
</div>
